import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 py-12 text-center border-t border-gray-200 dark:border-gray-800">
      <p className="text-gray-600 dark:text-gray-400 text-lg">
        © 2025 Guillermo Martín Correa
      </p>
    </footer>
  );
};

export default Footer;
